import authRules from '../authRules';

const addAssignmentViewPrices = (user) => {
  const { viewPrices } = user.securityLevels;
  if (viewPrices >= authRules.addAssignmentViewPrices.viewPrices) {
    return true;
  } else
  return false;
}

export default addAssignmentViewPrices;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentViewPrices.js